import { CoreDataSecurityApplicationsName } from './name';
import { getCoreDataSecurityApplicationsAllSlice } from './all/get';
import { getCoreDataSecurityAppUsersSlice } from '../app-users/get';
import { hideDataSecurityApplicationById } from '@api/data-security';
import { removeCoreDataSecurityApplicationSyncSlice } from './remove';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const hideCoreDataSecurityApplicationsSlice = createDeleteAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.APPLICATION_MODIFIED, (action) => action.data),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		preRequestActionCreators: [ removeCoreDataSecurityApplicationSyncSlice.syncActionCreator ],
		successActionCreators: [
			getCoreDataSecurityAppUsersSlice.asyncActionCreators.repeatGetCoreDataSecurityAppUsers,
			getCoreDataSecurityApplicationsAllSlice.asyncActionCreators.repeatGetCoreDataSecurityApplicationsAll
		]
	},
	name: CoreDataSecurityApplicationsName,
	receive: false,
	request: true,
	requestHandler: hideDataSecurityApplicationById
});
